import { getRequest } from "~/apis/requests/useApiCall";
import { ChangeHistory } from "~/types/changeHistory";

export const useChangeHistoriesStore = definePiniaStore(
  "changeHistoriesStore",
  {
    state: () => ({
      _loading: true,
      _changeHistories: [] as ChangeHistory[],
      _profileHistories: [] as any[],
      _nextCursor: null as string | null,
      _prevCursor: null as string | null,
      _profileHistoryCount: null as Number | null,
    }),
    actions: {
      async getHistories(trackable_type: string, trackable_id: number) {
        const url = `histories?trackable_type=${trackable_type}&trackable_id=${trackable_id}`;
        const { response, error } = await getRequest<ChangeHistory[]>(url);

        if (!error) {
          const { data } = response;
          this._changeHistories = data;
        }
      },
      async getProfileHistories(
        profileId: number,
        type:
          | "ticket"
          | "task"
          | "call"
          | "sms"
          | "lead"
          | "opportunity"
          | "order",
        cursor: string | null = null,
        returnType: "paginate" | "list" | "count" = "paginate",
      ) {
        if (returnType === "paginate") {
          if (this._prevCursor && this._nextCursor === null) {
            return;
          }
          if (
            this._prevCursor === null &&
            this._nextCursor === null &&
            this._profileHistories.length !== 0
          ) {
            return;
          }
        }
        if (!cursor && this._profileHistories.length === 0) {
          this._profileHistories = [];
        }

        this._loading = true;

        let url = `profiles/${profileId}/histories/${type}?return_type=${returnType}`;
        if (cursor) url += `&cursor=${cursor}`;

        const { response, error } = await getRequest<any>(url);

        if (!error) {
          if (returnType === "paginate") {
            const { data, next_cursor, prev_cursor } = response.data;
            this._profileHistories = [...this._profileHistories, ...data];
            this._nextCursor = next_cursor;
            this._prevCursor = prev_cursor;
          } else if (returnType === "list") {
            this._profileHistories = response.data;
          } else if (returnType === "count") {
            this._profileHistoryCount = response.data;
          }
        }

        this._loading = false;
      },

      resetCursors() {
        this._profileHistories = [];
        this._nextCursor = null;
        this._prevCursor = null;
      },
    },

    getters: {
      changeHistories: (state) => state._changeHistories,
      profileHistories: (state) => state._profileHistories,
      profileHistoryCount: (state) => state._profileHistoryCount,
    },
  },
);
